import React from 'react';
import { useTypedTranslation } from '@app/hooks';

import { ITrialDaysRemaining } from '@app/models';

interface IProps {
    trialDaysRemaining: ITrialDaysRemaining;
}

const TrialDaysRemaining: React.SFC<IProps> = ({ trialDaysRemaining }) => {
    const { translation } = useTypedTranslation();

    return (

        <div className='information--border information__content'>
            <h4 className='tile__content-header'>{GetDaysMessage(trialDaysRemaining)}</h4>

            <p>{translation('GS_TRIAL_DAYS_CONTACT')} <a href='mailto:passlysales@kaseya.com'>passlysales@kaseya.com</a></p>
        </div>

    );
};

function GetDaysMessage(trialDaysRemaining: ITrialDaysRemaining) {
    let daysMsg: string;
    const { translation } = useTypedTranslation();

    daysMsg = trialDaysRemaining.DaysRemaining.toString() + ' ';

    if (trialDaysRemaining.DaysRemaining === 1) {
        daysMsg += translation('GS_TRIAL_DAYS_POST_ONE_DAY');
    }
    else {
        daysMsg += translation('GS_TRIAL_DAYS_POST');
    }

    return daysMsg;
}

export default TrialDaysRemaining;
